import React from 'react';
import PropTypes from 'prop-types';

function TypeClean({ size, ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...otherProps}
    >
      <polyline points="6.30878906 4 19.8 4 19.8 6.96470588" />
      <path d="M6.6,19.8117647 L12.3,19.8117647" />
      <path d="M11.0767028,13.4587851 L9.36914046,19.4259097" />
      <path d="M13.4615263,4.15291784 L12.2436614,9.25498319" />
      <path d="M4.15113281,7.8671875 L4.15113281,7.8671875 C4.14626318,7.86206963 4.14646442,7.85397316 4.15158229,7.84910353 C4.15624399,7.84466794 4.16347507,7.84438587 4.16846813,7.84844483 L17.3237153,18.5426291 C17.3346125,18.5514877 17.3506277,18.549835 17.3594862,18.5389378 C17.3676003,18.5289565 17.3669824,18.5144876 17.3580469,18.5052344" />
    </svg>
  );
}

TypeClean.propTypes = {
  stroke: PropTypes.string.isRequired,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  strokeWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

export default TypeClean;
